import { useEffect, useState } from "react";
import { Save, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const CONDITIONS = [
    { key: "sujidade_elevada", label: "Sujidade elevada" },
    { key: "manchas", label: "Manchas" },
    { key: "odores", label: "Odores" },
    { key: "pelos_animais", label: "Pelos de animais" },
    { key: "urina_animais", label: "Urina de animais" },
    { key: "vomito", label: "Vómito" },
    { key: "humidade_bolor", label: "Humidade / bolor" },
    { key: "acaros_alergias", label: "Ácaros / alergias" },
];

export default function AdminPricing() {
    const [cfg, setCfg] = useState(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        (async () => {
            const { data } = await api.get("/pricing-config");
            setCfg({
                ...data,
                condition_surcharges: { ...CONDITIONS.reduce((acc, c) => ({ ...acc, [c.key]: 0 }), {}), ...data.condition_surcharges },
            });
        })();
    }, []);

    const save = async () => {
        setSaving(true);
        try {
            await api.put("/admin/pricing-config", cfg);
            toast.success("Configuração guardada");
        } catch (e) { toast.error(formatApiError(e)); }
        finally { setSaving(false); }
    };

    if (!cfg) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin" /></div>;

    return (
        <div className="space-y-6" data-testid="admin-pricing">
            <div>
                <h1 className="font-heading text-3xl font-bold tracking-tight">Preços & Condições</h1>
                <p className="text-white/60">Suplementos por estado, desinfeção, valor mínimo.</p>
            </div>

            <div className="ab-card p-8">
                <h2 className="font-heading font-bold text-lg mb-4">Suplementos por estado / necessidade (€)</h2>
                <div className="grid sm:grid-cols-2 gap-4">
                    {CONDITIONS.map((c) => (
                        <div key={c.key}>
                            <Label>{c.label}</Label>
                            <Input
                                type="number"
                                step="0.5"
                                value={cfg.condition_surcharges[c.key] || 0}
                                onChange={(e) => setCfg({ ...cfg, condition_surcharges: { ...cfg.condition_surcharges, [c.key]: Number(e.target.value) } })}
                                data-testid={`price-${c.key}`}
                            />
                        </div>
                    ))}
                </div>
            </div>

            <div className="ab-card p-8">
                <h2 className="font-heading font-bold text-lg mb-4">Outros</h2>
                <div className="grid sm:grid-cols-3 gap-4">
                    <div>
                        <Label>Desinfeção profissional (€)</Label>
                        <Input type="number" step="0.5" value={cfg.disinfection_surcharge} onChange={(e) => setCfg({ ...cfg, disinfection_surcharge: Number(e.target.value) })} data-testid="price-disinfect" />
                    </div>
                    <div>
                        <Label>Taxa deslocação por defeito (€)</Label>
                        <Input type="number" step="0.5" value={cfg.default_travel_fee} onChange={(e) => setCfg({ ...cfg, default_travel_fee: Number(e.target.value) })} data-testid="price-travel-default" />
                    </div>
                    <div>
                        <Label>Valor mínimo por serviço (€)</Label>
                        <Input type="number" step="0.5" value={cfg.minimum_order} onChange={(e) => setCfg({ ...cfg, minimum_order: Number(e.target.value) })} data-testid="price-minimum" />
                    </div>
                </div>
            </div>

            <div className="flex justify-end">
                <Button onClick={save} disabled={saving} className="ab-btn-primary rounded-full" data-testid="save-pricing">
                    {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />} Guardar alterações
                </Button>
            </div>
        </div>
    );
}
